import React from "react";
import ExcelViewer from "./ExcelViewer";
import Error from "../components/Error";

const DocumentViewer = ({ docUrl, fileType, fileName, fileError }) => {
  return (
    <>
     {fileError && (
              <Error message={fileError.message} />
      )}
      {fileType === "pdf" && (
        <div className="responsive-iframe">
          <iframe
            src={docUrl}
            width="100%"
            height="600px"
            title="Document Viewer"
            allowfullscreen
          ></iframe>
        </div>
      )}

      {fileType === "excel" && <ExcelViewer data={docUrl} />}


      
    </>
  );
};

export default DocumentViewer;
